import _ from "lodash";

export const getCaptchaSecretkey = (currentWebsite: any) => {
  return _.get(currentWebsite, "recaptcha.secretkey", "");
};
